// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Chat.css - NEW Button System Layout
 * Header + Split-screen chat interface
 */

.chat-page {
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 100vh;
  background: #000;
  font-family: 'Montserrat', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;
}

/* Header */
.chat-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #000000;
  border-bottom: 2px solid #ffffff;
  padding: 12px 24px;
  gap: 20px;
  flex-shrink: 0;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.5);
}

.header-left {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.header-left h1 {
  margin: 0;
  color: #e0e0e0;
  font-size: 24px;
  font-weight: 700;
  letter-spacing: 0.5px;
}

/* ── Flirtyfy logo wordmark ────────────────────────────── */
.flirtyfy-wordmark {
  font-weight: 800;
  letter-spacing: -0.5px;
  line-height: 1;
  display: inline-flex;
  align-items: baseline;
  gap: 0;
  -webkit-user-select: none;
          user-select: none;
}

.flirtyfy-word-flirty {
  background: linear-gradient(135deg, #e05fa0 0%, #9333ea 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.flirtyfy-word-fy {
  background: linear-gradient(135deg, #9333ea 0%, #6c4fc9 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.header-subtitle {
  margin: 0;
  color: #999;
  font-size: 12px;
  font-weight: 400;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

/* Navigation Buttons */
.btn-nav {
  padding: 8px 16px;
  background-color: #0a0a0a;
  border: 1px solid #333333;
  border-radius: 999px;
  color: #ccc;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-nav:hover {
  background-color: #1a1a1a;
  border-color: #ffffff;
  color: #ffffff;
}

.btn-nav:active {
  transform: scale(0.98);
}

.credits-badge {
  padding: 8px 14px;
  background: #0a0a0a;
  border: 1.5px solid #ffffff;
  border-radius: 999px;
  color: #ffffff;
  font-size: 12px;
  font-weight: 800;
  cursor: pointer;
  transition: all 0.15s ease;
  box-shadow: 0 0 10px rgba(255, 255, 255, 0.15);
}

.credits-badge--premium {
  background: #ffffff;
  border-color: #ffffff;
  color: #000000;
  cursor: default;
  box-shadow: 0 0 10px rgba(255, 255, 255, 0.3);
}

.credits-badge:hover {
  background: #1a1a1a;
  box-shadow: 0 0 14px rgba(255, 255, 255, 0.3);
}

.user-name {
  color: #cccccc;
  font-size: 12px;
  font-weight: 600;
  padding: 0 8px;
}

.btn-logout {
  padding: 8px 16px;
  background: #0a0a0a;
  border: 1.5px solid #ffffff;
  border-radius: 999px;
  color: #ffffff;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-logout:hover {
  background: #ffffff;
  color: #000000;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(255, 255, 255, 0.25);
}

.btn-logout:active {
  transform: translateY(0);
}

/* Global time bar — full width below header, applies to both panels */
.time-bar {
  display: flex;
  align-items: center;
  gap: 7px;
  padding: 10px 24px;
  background: #000000;
  border-bottom: 1px solid #222222;
  flex-shrink: 0;
}

.time-bar-label {
  font-size: 11px;
  font-weight: 700;
  color: #888888;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  white-space: nowrap;
  margin-right: 4px;
}

.time-chip {
  flex: 1 1;
  padding: 10px 6px;
  background: #0a0a0a;
  border: 1.5px solid #2a2a2a;
  border-radius: 9px;
  color: #999999;
  cursor: pointer;
  font-size: 13px;
  font-weight: 700;
  text-align: center;
  transition: all 0.15s ease;
  white-space: nowrap;
  letter-spacing: 0.2px;
  min-height: 44px;
}

.time-chip.active {
  background: #1a1a1a;
  border-color: #ffffff;
  color: #ffffff;
  box-shadow: 0 0 10px rgba(255, 255, 255, 0.25);
}

.time-chip:hover:not(.active) {
  border-color: #555555;
  color: #ffffff;
  background: #141414;
}

@media (max-width: 768px) {
  .time-bar { padding: 8px 16px; gap: 5px; }
  .time-chip { font-size: 11px; min-height: 40px; }
}

@media (max-width: 480px) {
  .time-bar { padding: 6px 10px; gap: 4px; }
  .time-bar-label { display: none; }
  .time-chip { font-size: 10px; padding: 8px 3px; min-height: 38px; }
}

/* Time check-in modal */
.time-checkin-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.75);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.time-checkin-modal {
  background: #0a0a0a;
  border: 1.5px solid #333333;
  border-radius: 12px;
  padding: 22px 24px;
  max-width: 360px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.5);
}

.time-checkin-text {
  margin: 0 0 16px 0;
  color: #ffffff;
  font-size: 14px;
  line-height: 1.5;
}

.time-checkin-actions {
  display: flex;
  gap: 10px;
}

.time-checkin-btn {
  flex: 1 1;
  padding: 9px 10px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  border: 1.5px solid #333333;
  transition: all 0.15s ease;
}

.time-checkin-btn.keep {
  background: #1a1a1a;
  color: #ffffff;
  border-color: #ffffff;
}

.time-checkin-btn.keep:hover {
  background: #262626;
}

.time-checkin-btn.switch {
  background: #0a0a0a;
  color: #cccccc;
}

.time-checkin-btn.switch:hover {
  border-color: #ffffff;
  color: #ffffff;
}

/* Chat Interface Wrapper */
.chat-interface-wrapper {
  flex: 1 1;
  display: flex;
  overflow: hidden;
  width: 100%;
}

/* Responsive */
@media (max-width: 768px) {
  .chat-header {
    flex-direction: column;
    padding: 12px 16px;
    gap: 12px;
    align-items: flex-start;
  }

  .header-left h1 {
    font-size: 18px;
  }

  .header-subtitle {
    font-size: 11px;
  }

  .header-right {
    width: 100%;
    justify-content: flex-start;
  }

  .btn-nav {
    padding: 6px 12px;
    font-size: 11px;
  }

  .user-name {
    font-size: 11px;
  }

  .btn-logout {
    padding: 6px 12px;
    font-size: 11px;
  }
}

@media (max-width: 480px) {
  .chat-header {
    padding: 10px 12px;
  }

  .header-left h1 {
    font-size: 16px;
  }

  .header-subtitle {
    font-size: 10px;
  }

  .header-right {
    gap: 8px;
  }

  .btn-nav {
    padding: 6px 10px;
    font-size: 10px;
  }

  .user-name {
    font-size: 10px;
    padding: 0 4px;
  }

  .btn-logout {
    padding: 6px 10px;
    font-size: 10px;
  }
}

/* ── Time selection modal grid (chips reuse .time-chip styles) ─────────── */
.time-modal-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: center;
  margin: 14px 0;
}
`, "",{"version":3,"sources":["webpack://./src/components/Chat.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAEF;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,8FAA8F;AAChG;;AAEA,WAAW;AACX;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,gCAAgC;EAChC,kBAAkB;EAClB,SAAS;EACT,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA,6DAA6D;AAC7D;EACE,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,oBAAoB;EACpB,qBAAqB;EACrB,MAAM;EACN,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA,uBAAuB;AACvB;EACE,iBAAiB;EACjB,yBAAyB;EACzB,yBAAyB;EACzB,oBAAoB;EACpB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,2BAA2B;EAC3B,oBAAoB;EACpB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,2BAA2B;EAC3B,oBAAoB;EACpB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,2BAA2B;EAC3B,gDAAgD;AAClD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,sEAAsE;AACtE;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;EAC1B,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,8CAA8C;AAChD;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,YAAY,iBAAiB,EAAE,QAAQ,EAAE;EACzC,aAAa,eAAe,EAAE,gBAAgB,EAAE;AAClD;;AAEA;EACE,YAAY,iBAAiB,EAAE,QAAQ,EAAE;EACzC,kBAAkB,aAAa,EAAE;EACjC,aAAa,eAAe,EAAE,gBAAgB,EAAE,gBAAgB,EAAE;AACpE;;AAEA,wBAAwB;AACxB;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA,2BAA2B;AAC3B;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,WAAW;AACb;;AAEA,eAAe;AACf;EACE;IACE,sBAAsB;IACtB,kBAAkB;IAClB,SAAS;IACT,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,2BAA2B;EAC7B;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;AACF;;AAEA,6EAA6E;AAC7E;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,uBAAuB;EACvB,cAAc;AAChB","sourcesContent":["/**\n * Chat.css - NEW Button System Layout\n * Header + Split-screen chat interface\n */\n\n.chat-page {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  min-height: 100vh;\n  background: #000;\n  font-family: 'Montserrat', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;\n}\n\n/* Header */\n.chat-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background: #000000;\n  border-bottom: 2px solid #ffffff;\n  padding: 12px 24px;\n  gap: 20px;\n  flex-shrink: 0;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.5);\n}\n\n.header-left {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.header-left h1 {\n  margin: 0;\n  color: #e0e0e0;\n  font-size: 24px;\n  font-weight: 700;\n  letter-spacing: 0.5px;\n}\n\n/* ── Flirtyfy logo wordmark ────────────────────────────── */\n.flirtyfy-wordmark {\n  font-weight: 800;\n  letter-spacing: -0.5px;\n  line-height: 1;\n  display: inline-flex;\n  align-items: baseline;\n  gap: 0;\n  user-select: none;\n}\n\n.flirtyfy-word-flirty {\n  background: linear-gradient(135deg, #e05fa0 0%, #9333ea 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.flirtyfy-word-fy {\n  background: linear-gradient(135deg, #9333ea 0%, #6c4fc9 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.header-subtitle {\n  margin: 0;\n  color: #999;\n  font-size: 12px;\n  font-weight: 400;\n}\n\n.header-right {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n/* Navigation Buttons */\n.btn-nav {\n  padding: 8px 16px;\n  background-color: #0a0a0a;\n  border: 1px solid #333333;\n  border-radius: 999px;\n  color: #ccc;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.btn-nav:hover {\n  background-color: #1a1a1a;\n  border-color: #ffffff;\n  color: #ffffff;\n}\n\n.btn-nav:active {\n  transform: scale(0.98);\n}\n\n.credits-badge {\n  padding: 8px 14px;\n  background: #0a0a0a;\n  border: 1.5px solid #ffffff;\n  border-radius: 999px;\n  color: #ffffff;\n  font-size: 12px;\n  font-weight: 800;\n  cursor: pointer;\n  transition: all 0.15s ease;\n  box-shadow: 0 0 10px rgba(255, 255, 255, 0.15);\n}\n\n.credits-badge--premium {\n  background: #ffffff;\n  border-color: #ffffff;\n  color: #000000;\n  cursor: default;\n  box-shadow: 0 0 10px rgba(255, 255, 255, 0.3);\n}\n\n.credits-badge:hover {\n  background: #1a1a1a;\n  box-shadow: 0 0 14px rgba(255, 255, 255, 0.3);\n}\n\n.user-name {\n  color: #cccccc;\n  font-size: 12px;\n  font-weight: 600;\n  padding: 0 8px;\n}\n\n.btn-logout {\n  padding: 8px 16px;\n  background: #0a0a0a;\n  border: 1.5px solid #ffffff;\n  border-radius: 999px;\n  color: #ffffff;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.btn-logout:hover {\n  background: #ffffff;\n  color: #000000;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(255, 255, 255, 0.25);\n}\n\n.btn-logout:active {\n  transform: translateY(0);\n}\n\n/* Global time bar — full width below header, applies to both panels */\n.time-bar {\n  display: flex;\n  align-items: center;\n  gap: 7px;\n  padding: 10px 24px;\n  background: #000000;\n  border-bottom: 1px solid #222222;\n  flex-shrink: 0;\n}\n\n.time-bar-label {\n  font-size: 11px;\n  font-weight: 700;\n  color: #888888;\n  text-transform: uppercase;\n  letter-spacing: 0.8px;\n  white-space: nowrap;\n  margin-right: 4px;\n}\n\n.time-chip {\n  flex: 1;\n  padding: 10px 6px;\n  background: #0a0a0a;\n  border: 1.5px solid #2a2a2a;\n  border-radius: 9px;\n  color: #999999;\n  cursor: pointer;\n  font-size: 13px;\n  font-weight: 700;\n  text-align: center;\n  transition: all 0.15s ease;\n  white-space: nowrap;\n  letter-spacing: 0.2px;\n  min-height: 44px;\n}\n\n.time-chip.active {\n  background: #1a1a1a;\n  border-color: #ffffff;\n  color: #ffffff;\n  box-shadow: 0 0 10px rgba(255, 255, 255, 0.25);\n}\n\n.time-chip:hover:not(.active) {\n  border-color: #555555;\n  color: #ffffff;\n  background: #141414;\n}\n\n@media (max-width: 768px) {\n  .time-bar { padding: 8px 16px; gap: 5px; }\n  .time-chip { font-size: 11px; min-height: 40px; }\n}\n\n@media (max-width: 480px) {\n  .time-bar { padding: 6px 10px; gap: 4px; }\n  .time-bar-label { display: none; }\n  .time-chip { font-size: 10px; padding: 8px 3px; min-height: 38px; }\n}\n\n/* Time check-in modal */\n.time-checkin-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.75);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.time-checkin-modal {\n  background: #0a0a0a;\n  border: 1.5px solid #333333;\n  border-radius: 12px;\n  padding: 22px 24px;\n  max-width: 360px;\n  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.5);\n}\n\n.time-checkin-text {\n  margin: 0 0 16px 0;\n  color: #ffffff;\n  font-size: 14px;\n  line-height: 1.5;\n}\n\n.time-checkin-actions {\n  display: flex;\n  gap: 10px;\n}\n\n.time-checkin-btn {\n  flex: 1;\n  padding: 9px 10px;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 700;\n  cursor: pointer;\n  border: 1.5px solid #333333;\n  transition: all 0.15s ease;\n}\n\n.time-checkin-btn.keep {\n  background: #1a1a1a;\n  color: #ffffff;\n  border-color: #ffffff;\n}\n\n.time-checkin-btn.keep:hover {\n  background: #262626;\n}\n\n.time-checkin-btn.switch {\n  background: #0a0a0a;\n  color: #cccccc;\n}\n\n.time-checkin-btn.switch:hover {\n  border-color: #ffffff;\n  color: #ffffff;\n}\n\n/* Chat Interface Wrapper */\n.chat-interface-wrapper {\n  flex: 1;\n  display: flex;\n  overflow: hidden;\n  width: 100%;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .chat-header {\n    flex-direction: column;\n    padding: 12px 16px;\n    gap: 12px;\n    align-items: flex-start;\n  }\n\n  .header-left h1 {\n    font-size: 18px;\n  }\n\n  .header-subtitle {\n    font-size: 11px;\n  }\n\n  .header-right {\n    width: 100%;\n    justify-content: flex-start;\n  }\n\n  .btn-nav {\n    padding: 6px 12px;\n    font-size: 11px;\n  }\n\n  .user-name {\n    font-size: 11px;\n  }\n\n  .btn-logout {\n    padding: 6px 12px;\n    font-size: 11px;\n  }\n}\n\n@media (max-width: 480px) {\n  .chat-header {\n    padding: 10px 12px;\n  }\n\n  .header-left h1 {\n    font-size: 16px;\n  }\n\n  .header-subtitle {\n    font-size: 10px;\n  }\n\n  .header-right {\n    gap: 8px;\n  }\n\n  .btn-nav {\n    padding: 6px 10px;\n    font-size: 10px;\n  }\n\n  .user-name {\n    font-size: 10px;\n    padding: 0 4px;\n  }\n\n  .btn-logout {\n    padding: 6px 10px;\n    font-size: 10px;\n  }\n}\n\n/* ── Time selection modal grid (chips reuse .time-chip styles) ─────────── */\n.time-modal-grid {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  justify-content: center;\n  margin: 14px 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
